import { useEffect, useState, useContext } from "react";
import ProjectBlobNarrow from "./ProjectBlobNarrow";
import { userContext } from '../../contexts/userContext';
import serverURL from "../../config/serverConfig";
import { ChartNoAxesGantt, Disc3, DiscAlbum, Search, GripHorizontal } from 'lucide-react';
import { Link } from "react-router-dom";
import ProjectBasket from "./ProjectBasket";
import { Loader } from 'lucide-react';

import { all } from "axios";



export const Projects = () => {
    const user_id = useContext(userContext);
    const [searchTerm, setSearchTerm] = useState("");
    const [allProjects, setAllProjects] = useState([]);

    const projectCategories = [
        { status: "Not Started", label: "Not Started", color: "#DC0000" },
        { status: "Awaiting Assets", label: "Awaiting Assets", color: "#FF3300" },
        { status: "In Progress", label: "In Progress", color: "#ff7700" },
        { status: "Awaiting Feedback", label: "Awaiting Feedback", color: "#ffb200" },
        { status: "Revising", label: "Revising", color: "#ffee00" },
        { status: "Mastering", label: "Mastering", color: "#B2DF00" },
        { status: "Delivering", label: "Delivering", color: "#46C408" },
        { status: "Complete", label: "Completed", color: "#00a116" }
    ];

    const [projectLists, setProjectLists] = useState(
        Object.fromEntries(projectCategories.map(c => [c.status, []]))
    );

    useEffect(() => {
        fetch(`${serverURL}getUserProjects`, {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_id: user_id[0] }),
        })
            .then(response => response.json())
            .then(jsonData => {
                setAllProjects(jsonData);
                // console.log(jsonData)
            })
            .catch(error => {
                console.error("Error fetching projects:", error);
            });
    }, [user_id]);

    useEffect(() => {
        const temp = Object.fromEntries(projectCategories.map(c => [c.status, []]));

        const filtered = allProjects.filter(project => {
            const term = searchTerm.toLowerCase();
            return (
                project.client?.toLowerCase().includes(term) ||
                project.title?.toLowerCase().includes(term) ||
                project.status?.toLowerCase().includes(term)
            );
        });

        // for (const project of filtered) {
        //     if (temp[project.status]) {
        //         temp[project.status].push(
        //             <Link
        //                 to="/project"
        //                 state={{ project_id: project.project_id }}
        //                 key={project.project_id}
        //             >
        //                 <ProjectBlobNarrow project={project} />
        //             </Link>
        //         );
        //     }
        // }

        setProjectLists(filtered);
    }, [searchTerm, allProjects]);
    console.log(projectLists)
    console.log(allProjects)

    return (
        <div className="m-auto mt-6 px-10 max-w-[1200px] flex flex-col self-center">
            {/* Header + Filter */}
            <h5 className="uppercase text-xs tracking-wider">Projects</h5>
            <div className="hBar mt-[2px] mb-[10px]"></div>
            <div className="flex flex-row justify-between pt-3">
                <Link to="/createproject" id="newProjectLink" className="w-[200px]">
                    <button className="py-0 px-2 flex-left bg-[#ffee00] rounded-md uppercase font-semibold text-sm text-[black] hoverUp hover:text-[#666]">
                        + create new project
                    </button>
                </Link>
                <div className="float-right flex items-center gap-3">
                    <span className="flex items-center gap-1 text-[#444] text-[10px] tracking-wide">
                        <GripHorizontal size={11}/> drag to change status
                    </span>
                    <div className="relative">
                        <Search
                            color="#ffee00"
                            size={16}
                            className="absolute left-2 top-1/2 -translate-y-1/2 pointer-events-none"
                        />
                        <input
                            type="text"
                            placeholder="Filter projects..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="bg-[#111] border border-[#333] rounded-xl pl-8 pr-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-[#555] text-white"
                        />
                    </div>
                </div>

            </div>

            {/* show loading until projectLists exists */} 
            {projectLists?.length > 0 ? 
                <>
                    <div className="pt-2 m-auto mb-4 grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 gap-3">
                        <div className="flex flex-col gap-3">
                            <ProjectBasket projects={projectLists} category={projectCategories[0]} setProjects={setAllProjects}/>
                            <ProjectBasket projects={projectLists} category={projectCategories[1]} setProjects={setAllProjects}/>
                            <ProjectBasket projects={projectLists} category={projectCategories[2]} setProjects={setAllProjects}/>
                        </div>
                        <div className="flex flex-col gap-3">
                            <ProjectBasket projects={projectLists} category={projectCategories[3]} setProjects={setAllProjects}/>
                            <ProjectBasket projects={projectLists} category={projectCategories[4]} setProjects={setAllProjects}/>
                        </div>
                        <div className="flex flex-col gap-3">
                            <ProjectBasket projects={projectLists} category={projectCategories[5]} setProjects={setAllProjects}/>
                            <ProjectBasket projects={projectLists} category={projectCategories[6]} setProjects={setAllProjects}/>
                        </div>
                    </div>
                    <div>
                        <ProjectBasket projects={projectLists} category={projectCategories[7]} setProjects={setAllProjects}/>
                    </div>
                </>
            
            : 
                <>
                    <h3><Loader className="spinning"/></h3>
                </>
           }
        </div>
    );
};
